// extracted by mini-css-extract-plugin
export default {"container":"ExpressPayOption_container__V0+H1"};